import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleTheme } from "./features/theme/themeSlice";
import AboutMe from "./components/AboutMe";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Footer from "./components/Footer";

function App() {
  const darkMode = useSelector((state) => state.theme.darkMode);
  const dispatch = useDispatch();

  return (
    <div className={darkMode ? "dark-mode" : "light-mode"}>
      <nav>
        <h2 id="logo">Daniel Cserpak</h2>
        <ul className="navigation-items">
          <li><a href="#about-me">About Me</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#skills">Skills</a></li>
          <li><a href="#contact">Contact</a></li>
          <li>
            <button
              onClick={() => dispatch(toggleTheme())}
              className="theme-button"
            >
              {darkMode ? "☀️ Light" : "🌙 Dark"}
            </button>
          </li>
        </ul>
      </nav>

      <main>
        <AboutMe />
        <Projects />
        <Skills />
      </main>

      <Footer />
    </div>
  );
}

export default App;
